
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 139 122","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M97.94 25.217a3.861 3.861 0 00-3.86 3.86v18.665H75.412a3.861 3.861 0 000 7.72h18.666v18.664a3.86 3.86 0 007.723 0V55.463h18.665a3.86 3.86 0 100-7.72h-18.665V29.077a3.86 3.86 0 00-3.86-3.861h-.002zM75.412 107.97h45.054a3.861 3.861 0 000-7.722H75.412a3.862 3.862 0 000 7.722z","fill":"#fff"}}),_c('path',{attrs:{"d":"M135.138 0H58.225a3.865 3.865 0 00-3.755 2.962L30.879 101.57l-14.78-61.547a3.858 3.858 0 00-3.753-2.959H3.86a3.864 3.864 0 00-3.932 3.86 3.86 3.86 0 003.932 3.861h5.45l17.824 74.255a3.858 3.858 0 003.755 2.962 3.864 3.864 0 003.755-2.962L61.27 7.722h73.867a3.86 3.86 0 100-7.722z","fill":"#fff"}})])
          )
        }
      }
    